import { createFileRoute } from '@tanstack/react-router';

import { buildLoginRedirectOptions, collectLoginCampaignTags } from '#utils/auth0-campaign.js';
import { logInSearchSchema } from './log-in-search.js';

import type { Auth0AppState } from '#utils/auth0-app-state.js';

export const Route = createFileRoute('/_authorization-gate/log-in/')({
	validateSearch: logInSearchSchema,
	loaderDeps: ({ search }) => ({ search }),
	loader: async ({ context: { auth0Client }, deps: { search } }) => {
		await auth0Client.loginWithRedirect<Auth0AppState>(
			buildLoginRedirectOptions({
				returnTo: '/',
				tags: collectLoginCampaignTags(search),
				screenHint: search.screen_hint,
			}),
		);

		// Stall until the redirect happens:
		await new Promise((resolve, reject) => setTimeout(() => reject(new Error('Timed out')), 60 * 1000));
		throw new Error('Login failed'); // Should be unreachable
	},
	pendingComponent: () => (
		<div className='grid w-full grow place-items-center'>
			<p>Logging in...</p>
		</div>
	),
});
